/* Header behaviours that Dawn does not ship:
   1. Shadow once the announcement bar has scrolled away (mockup .header.is-scrolled).
   2. A close button inside the right-hand drawer (the burger sits under the panel).
   3. Open desktop dropdown / mega panels on hover (Dawn opens on click only).
   Everything else (sticky, drawer, focus handling) stays with Dawn's own JS. */
(function () {
  'use strict';

  var section = document.querySelector('.section-header');
  if (!section) return;

  /* 1. Scroll shadow */
  var wrapper = section.querySelector('.header-wrapper');
  if (wrapper && wrapper.getAttribute('data-pa-shadow') === 'true') {
    var announceHeight = function () {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--pa-announce-h');
      return parseFloat(v) || 0;
    };
    var onScroll = function () {
      section.classList.toggle('pa-header--scrolled', window.scrollY > announceHeight());
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* 2. Drawer close button.
     Dawn binds every <button> inside <header-drawer> to onCloseButtonClick, which
     only closes a submenu and leaves the body scroll lock in place. Capturing the
     click at the document and stopping it there keeps that handler out of the way,
     so closeMenuDrawer() runs once and does the full teardown (open attribute,
     overflow class, focus trap, focus returned to the burger). */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.pa-drawer__close');
      if (!button) return;
      var drawer = button.closest('header-drawer, menu-drawer');
      var summary = drawer && drawer.querySelector('summary.header__icon--menu');
      if (!drawer || !summary || typeof drawer.closeMenuDrawer !== 'function') return;
      event.preventDefault();
      event.stopPropagation();
      drawer.closeMenuDrawer(event, summary);
    },
    true
  );

  /* 3. Hover-open menus on desktop */
  var desktop = window.matchMedia('(min-width: 990px)');
  var hoverable = window.matchMedia('(hover: hover)');
  section.querySelectorAll('.pa-nav header-menu').forEach(function (menu) {
    var details = menu.querySelector('details');
    if (!details) return;
    var timer;
    menu.addEventListener('mouseenter', function () {
      if (!desktop.matches || !hoverable.matches) return;
      clearTimeout(timer);
      if (!details.open) details.open = true;
    });
    menu.addEventListener('mouseleave', function () {
      if (!desktop.matches || !hoverable.matches) return;
      timer = setTimeout(function () {
        if (details.open) details.open = false;
      }, 120);
    });
  });
})();
